exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".norgie--norgie--2Xwz0:after{content:\"\\203A\";font-size:15px;font-weight:700;padding-left:8px;margin-right:16px;transform:rotate(0deg);transition-duration:.25s;transition-property:rotate,transform}.norgie--opened--2KlAx:after{transform:rotate(90deg) translate(-20%,-15%)}@media print{.norgie--norgie--2Xwz0:after{content:\"\"}}", ""]);

// exports
exports.locals = {
	"norgie": "norgie--norgie--2Xwz0",
	"opened": "norgie--opened--2KlAx"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!./~/postcss-loader!./src/components/settings/common/norgie.css
 ** module id = 83
 ** module chunks = 0
 **/